module.exports = __webpack_public_path__ + "static/img/p6.ad3d68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6.png
// module id = 248
// module chunks = 1